import React from 'react'
import { connect } from 'react-redux'
import { Scrollbars } from 'react-custom-scrollbars'
import { Switch } from 'antd'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'

import styles from './style.module.scss'

const mapStateToProps = ({ settings }) => ({ settings })

@connect(mapStateToProps)
class Settings extends React.Component {
  changeSetting = (setting, value) => {
    const { dispatch } = this.props
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting,
        value,
      },
    })
  }

  closeSettings = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isSettingsOpen',
        value: false,
      },
    })
  }

  render() {
    const {
      settings: {
        isLightTheme,
        isSettingsOpen,
        isMenuTop,
        isMenuCollapsed,
        isBorderless,
        isMenuShadow,
        isSquaredBorders,
        isFixedWidth,
      },
    } = this.props

    return (
      <div
        className={isSettingsOpen ? `${styles.settings} ${styles.settingsOpened}` : styles.settings}
      >
        <Scrollbars className={styles.settingsHeight}>
          <div className={styles.container}>
            <div className={styles.title}>
              <FormattedMessage id="settings.title" />
              <button
                className={`${styles.close} fa fa-times`}
                onClick={this.closeSettings}
                type="button"
                aria-label="close-settings"
              />
            </div>
            <div className={styles.description}>
              <FormattedHTMLMessage id="settings.description" />
            </div>
            <div className={styles.item}>
              <Switch
                checked={isMenuTop}
                onChange={value => {
                  this.changeSetting('isMenuTop', value)
                }}
              />
              <span className={styles.itemLabel}>
                <FormattedMessage id="settings.menuTop" />
              </span>
            </div>
            <div className={styles.item}>
              <Switch
                disabled={isMenuTop}
                checked={isMenuCollapsed && !isMenuTop}
                onChange={value => {
                  this.changeSetting('isMenuCollapsed', value)
                }}
              />
              <span className={styles.itemLabel}>
                <FormattedMessage id="settings.menuCollapsed" />
              </span>
            </div>
            <div className={styles.item}>
              <Switch
                disabled={isMenuTop}
                checked={isMenuShadow && !isMenuTop}
                onChange={value => {
                  this.changeSetting('isMenuShadow', value)
                }}
              />
              <span className={styles.itemLabel}>
                <FormattedMessage id="settings.menuShadow" />
              </span>
            </div>
            <div className={styles.item}>
              <Switch
                disabled // TODO: Needs full app dark mode
                checked={isLightTheme}
                onChange={value => {
                  this.changeSetting('isLightTheme', value)
                }}
              />
              <span className={styles.itemLabel}>
                <FormattedMessage id="settings.isLightTheme" />
              </span>
            </div>
            <div className={styles.item}>
              <Switch
                disabled // TODO: Needs full app clean borders
                checked={isBorderless}
                onChange={value => {
                  this.changeSetting('isBorderless', value)
                }}
              />
              <span className={styles.itemLabel}>
                <FormattedMessage id="settings.isBorderless" />
              </span>
            </div>
            <div className={styles.item}>
              <Switch
                checked={isSquaredBorders}
                onChange={value => {
                  this.changeSetting('isSquaredBorders', value)
                }}
              />
              <span className={styles.itemLabel}>
                <FormattedMessage id="settings.isSquaredBorders" />
              </span>
            </div>
            <div className={styles.item}>
              <Switch
                checked={isFixedWidth}
                onChange={value => {
                  this.changeSetting('isFixedWidth', value)
                }}
              />
              <span className={styles.itemLabel}>
                <FormattedMessage id="settings.isFixedWidth" />
              </span>
            </div>
          </div>
        </Scrollbars>
      </div>
    )
  }
}

export default Settings
